
import React from "react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Group, Product } from "@/lib/types";

export interface GroupWithProducts extends Omit<Group, 'productIds'> {
  products: Array<Product & {
    quantity: number;
  }>;
}

export interface GroupUsageCardProps {
  group: GroupWithProducts;
  onTrackUsage: () => void;
}

const GroupUsageCard: React.FC<GroupUsageCardProps> = ({ group, onTrackUsage }) => {
  const { name, products } = group;
  
  return (
    <Card className="shadow-sm h-full flex flex-col">
      <CardHeader className="pb-2">
        <CardTitle className="text-lg">{name}</CardTitle>
      </CardHeader>
      
      <CardContent className="flex-1">
        <div className="space-y-2">
          {products.length === 0 ? (
            <p className="text-sm text-gray-500">No products in this group</p>
          ) : (
            <ul className="space-y-1.5">
              {products.slice(0, 3).map(product => (
                <li key={product.id} className="text-sm flex justify-between">
                  <span className="font-medium">{product.name}</span>
                  <span className="text-gray-600">×{product.quantity}</span>
                </li>
              ))}
              
              {products.length > 3 && (
                <li className="text-xs text-gray-500 italic">
                  +{products.length - 3} more items
                </li>
              )}
            </ul>
          )}
        </div>
      </CardContent>
      
      <CardFooter>
        <Button 
          onClick={onTrackUsage} 
          className="w-full"
          disabled={products.length === 0}
        >
          Track Usage
        </Button>
      </CardFooter>
    </Card>
  );
};

export default GroupUsageCard;
